import { render, staticRenderFns } from "./UpdateMain.vue?vue&type=template&id=a911ffd6"
import script from "./UpdateMain.vue?vue&type=script&lang=js"
export * from "./UpdateMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports